exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.tab-content {\n  margin: auto; }\n\n.span-plan-comercial {\n  margin-left: 10px;\n  font-size: small;\n  font-weight: 500;\n  color: #2cc5a9;\n  padding: 2px;\n  background-color: #e9faf6; }\n\n.plan-active {\n  color: #2cc5a9; }\n\n/* Estilos para pantalla normal */\n.span-plan-comercial-mobile {\n  display: none; }\n\n/* Estilos para pantalla móvil */\n@media screen and (max-width: 768px) {\n  .span-plan-comercial {\n    display: none; }\n  .span-plan-comercial-mobile {\n    display: inline-block;\n    margin-left: 10px;\n    font-size: small;\n    font-weight: 500;\n    color: #2cc5a9;\n    padding: 2px;\n    background-color: #e9faf6; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/abm/abm.component.scss
// module id = ../../../../../src/app/components/abm/abm/abm.component.scss
// module chunks = 0